<template>
  <div class='Divider' :style="style"></div>
</template>

<script>
export default {
  name: 'Divider',

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  computed: {
    style () {
      return {
        borderStyle: this.data.controls.tiekuorg
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
  .Divider
    border 1px solid #dbe3ef
    margin 20px 0
</style>
